import http from 'services/http';

export interface UnlockInsightsResult {
  unlocked: true;
  /** False when nothing was spent (already unlocked). */
  charged: boolean;
  analysesRemaining: number | null;
}

/** Spends one plan analysis credit on this IELTS/SAT attempt. 403 `PORTAL_PLAN_REQUIRED` / `ANALYSIS_LIMIT_REACHED` otherwise. */
export async function unlockAttemptInsights(attemptId: string): Promise<UnlockInsightsResult> {
  const { data } = await http.request.post<{ data: UnlockInsightsResult }>(
    `/api/exam-insights/attempts/${encodeURIComponent(attemptId)}/unlock`,
  );
  return data.data;
}

/** The API's refusal code for an unlock or a locked analysis, if any. */
export function insightsErrorCode(error: unknown): string | undefined {
  const code = (error as { response?: { data?: { code?: unknown } } } | null)?.response?.data?.code;
  return typeof code === 'string' ? code : undefined;
}
